export default "__VITE_ASSET__1c6d9f58__"